export const SET_ANNOTATIONS_LOCK = 'SET_ANNOTATIONS_LOCK';

const setAnnotationsLock = (state, payload = {}) => {
  const { annotationIds = [], locked = false } = payload;
  if (annotationIds.length === 0) {
    return state;
  }

  let annotations = state.annotations;
  let changed = false;

  annotationIds.forEach((id) => {
    const existing = annotations[id];
    if (!existing || Boolean(existing.locked) === Boolean(locked)) {
      return;
    }
    if (!changed) {
      annotations = { ...state.annotations };
      changed = true;
    }
    annotations[id] = {
      ...existing,
      locked,
    };
  });

  if (!changed) {
    return state;
  }

  return {
    ...state,
    isDesignState: true,
    annotations,
  };
};

export default setAnnotationsLock;
